export default {
	global: {
		appVersion: '1.2.0',
		appDefaultEntryPoint: 'home',
		baseUrl: '/lspi_server'
	},
	menu: {
		keepExpanded: true,
		searchBtn: false,
		helpBtn: false,
		notificationsBtn: false
	}
};
